<template>
  <div class="page">

  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  data() {
    return {

    }
  },
  mounted() {
    let that = this
    console.log(that.$route.query);
    let access_token = that.$route.query.access_token
    if (access_token) {
      localStorage.setItem('access_token', access_token);
      if (that.$route.query.return_url) {
        window.location.href = that.$route.query.return_url
      } else {
        that.$router.replace('/')
      }
    }
  },
  methods: {
  }
}
</script>
